/**
 * @Author: Zero
 * @Date: 2024-10-24 17:28:13
 * @Explain: 联系人新增 - csv导入
 */

export default {
  /** 上传文件大小不在限制范围内 */
  100: 'contactsUploadFileSizeOver',
  /** 上传文件数量限制 */
  101: 'contactsUploadFileNumOver',
  /** 文件名称过长报错 */
  102: 'contactsUploadFileNameOver',
  /** 文件类型不符报错 */
  103: 'contactsUploadFileTypeOver',
  /** 文件解码错误 */
  104: 'contactsUploadFileDecodeError',
  /** 文件读取错误 */
  105: 'contactsUploadReadFileError',
  /** 表头之间信息不能为空 */
  106: 'contactsUploadFileHeaderHasEmpty',
  /** 文件内容为空 */
  107: 'contactsUploadFileEmpty',
  /** 删除空行过程失败 */
  108: 'contactsUploadFileDeleteEmptyRowError',
  /** 上报匹配表格内xxx列不可导入 */
  109: 'contactsMatchAttributeUnImported',
  /** 存在空邮箱 */
  110: 'contactsCheckAttributeEmailIsEmpty',
  /** xxxx邮箱格式检测错误 */
  111: 'contactsCheckAttributeEmail',
  /** `$[{email}...] 等${12}个邮箱域名无效` */
  112: 'contactsCheckAttributeDomin',
  /** 接口验证前读取缓存的域名校验结果信息xxxxx */
  113: 'contactsCheckEmailDominSesstionInfo',
  /** 本次经过接口验证的域名结果信息xxxxx */
  114: 'contactsCheckEmailDominCurrentByApiInfo',
  /** $[{email}...] 等${12}个重复邮箱 */
  115: 'contactsCheckAttributeEmailIsRepeat',
  /** 地区编码错误、语言编码错误、偏好错误、标签错误、Dropdown类型自定义字段错误、其它类型自定义字段错误... */
  116: 'contactsCheckAttributeOthers',
  /** xxx.csv前端校验耗时xxms */
  117: 'contactsCheckAttributeFeCost',
  /** xxx.csv接口校验域名耗时xxms */
  118: 'contactsCheckDomainBeCost',
  /** 上报文件上传GCP前端耗时xxms */
  119: 'contactsCsvUploadGcpFeCost',
  /** 上报文件上传GCP接口耗时xxms */
  120: 'contactsCsvUploadGcpBeCost',
};
